import { render, staticRenderFns } from "./control5Leavingmessage.vue?vue&type=template&id=08be6372&scoped=true&"
import script from "./control5Leavingmessage.vue?vue&type=script&lang=js&"
export * from "./control5Leavingmessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08be6372",
  null
  
)

export default component.exports